import { makeStyles } from 'tss-react/mui';

const name = 'StatusIcon';

export const useStatusIconStyles = makeStyles({ name })(theme => ({
  iconSuccess: {
    color: theme.palette.success.dark,
  },
  iconWarning: {
    color: theme.palette.warning.dark,
  },
  iconError: {
    color: theme.palette.error.dark,
    width: 18,
    height: 18,
  },
  iconNoData: {
    color: theme.palette.text.secondary,
  },
}));
